import type { FaireProductEntity } from "../../entity_types/product";

export const p_zacftspk2p: FaireProductEntity = {
  token: "p_zacftspk2p",
  type: "product",
  name: "Holiday Incense: Fraser Fir",
  brandToken: "b_b19tidse3g",
  brandName: "BOTANICA",
  imageUrl:
    "https://cdn.faire.com/fastly/995313102b817ec09351e7c2413635061c2f2d1431c0b472e1e0a30dade6bc7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52ada1db01a62ad3ed15509a1b0693674a09b57c6d8b4ddb34c8d9df6ea84a7f.jpeg",
    "https://cdn.faire.com/fastly/bc68e657796f1f780e9da8e7aaafc484803ca63a69dd305838bf417877be7040.jpeg",
    "https://cdn.faire.com/fastly/8da45343a88e32f2e902c5598ccdf3e2ca8fed1304fbdcfbd52e9cd2c2fba287.jpeg",
    "https://cdn.faire.com/fastly/cadc1f850c5fbdd484242e547ea906393adf4fa9cca479897d9db6c651310183.jpeg",
    "https://cdn.faire.com/fastly/46777ef798047e95cd6ed13958aeca1c47499626c1d0173d1ff45fff9b967a85.jpeg",
    "https://cdn.faire.com/fastly/35a4afdcf0892bf215e1341ffc8b45056030389252138e339f70d242c713cc33.jpeg",
    "https://cdn.faire.com/fastly/b95be30532e9c4adc3c4a56432ce42e03ac261563f53d23bda979c33baa141cc.jpeg",
  ],
  priceDollars: 12,
  description:
    "New for 2026, our Holiday Collection includes six favorite fragrances that celebrate the best of the season. Fraser Fir stays true to the fresh and crisp notes of this evergreen fir tree, and we combined it with a hint of amber to warm up this well-rounded candle. Timeless for a reason, this traditional holiday blend is a customer favorite every year.\n\nFragrance Notes: Amber, Fraser Fir, Lemon Zest\n\n• 20 Incense Sticks\n• Handmade in the USA\n• Recycled Content Gift Box\n\n\n\n\n\n\n\nSEO Keywords:\nHoliday gift idea, holiday candle, Christmas, Christmas gift idea, holiday fragrance, holiday scent, Thanksgiving, Christmas candle, fresh, hostess gift, boutique candle, best seller, best selling, classic christmas, christmas tree, winter candle, soy candle, Christmas candle, Christmas fragrance, balsam fir, holiday hostess gift, Christmas tree candle, candle gifts, natural candle fragrance, Botanica candles, fresh pine scented holiday candles, non-toxic holiday candles, holiday gift guide, gifts for him, gifts for her, Fraser Fir candle, Frasier Fir, non-toxic incense, Fraser Fir incense, Frasier fir incense",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:19.521Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
